module.exports = {
          srcSet: __webpack_public_path__ + "public/086e8d9aaf3081d86d3e8d5ae8d971f0-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/086e8d9aaf3081d86d3e8d5ae8d971f0-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/086e8d9aaf3081d86d3e8d5ae8d971f0-80.png",
          toString:function(){return __webpack_public_path__ + "public/086e8d9aaf3081d86d3e8d5ae8d971f0-80.png"},
          
          width: 80,
          height: 80
        }